"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSearchTxQueryArray = isSearchTxQueryArray;
function isSearchTxQueryArray(query) {
    return Array.isArray(query);
}
